const moduleReducer = (
  state = {
    moduleLibrary: { modulesList: [], loading: true },
    moduleTemplates: []
  },
  action
) => {
  switch (action.type) {
    case 'ADD_MODULE':
      return [...state, action.payload];
    case 'SET_MODULES':
      return {
        ...state,
        moduleLibrary: { modulesList: action.payload, loading: false }
      };
    case 'SET_MODULES_LOADING':
      return {
        ...state,
        moduleLibrary: { ...state.moduleLibrary, loading: true }
      };
    case 'SET_MODULE_TEMPLATES':
      return { ...state, moduleTemplates: action.payload };
    default:
      return state;
  }
};

export default moduleReducer;
